module.exports = __webpack_public_path__ + "static/img/2s-info-b3.1de5757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-info-b3.jpg
// module id = tN3s
// module chunks = 0